import { render, staticRenderFns } from "./InputDatepickerCustom.vue?vue&type=template&id=16c4578a&scoped=true&"
import script from "./InputDatepickerCustom.vue?vue&type=script&lang=js&"
export * from "./InputDatepickerCustom.vue?vue&type=script&lang=js&"
import style0 from "./InputDatepickerCustom.vue?vue&type=style&index=0&id=16c4578a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c4578a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu})
